import styled from 'styled-components'

export const Container = styled.div`
width: 350px;
height: auto;
background: #f1f1f1;
margin: 4px 16px;
padding 5px;
border-radius: 5px;
`